import { Route, UrlMatcher } from '@angular/router';
import {
  MODERN_FRAME_NAMESPACES,
  getModernFrameDefaultRoute,
  isAllowedModernFrameRoute
} from '@platform/contracts';

import { createLogResolver } from '@core/logs/resolvers/create-log.resolver';
import { AUTH_GUARDS } from '@core/routing/route-guards';

export const modernFrameMatcher: UrlMatcher = (segments) =>
  isAllowedModernFrameRoute('/' + segments.map((segment) => segment.path).join('/'))
    ? { consumed: segments }
    : null;

export const MODERN_FRAME_ROOT_REDIRECTS = MODERN_FRAME_NAMESPACES
  .filter((entry) => entry.rootRedirect !== null)
  .map((entry) => ({
    path: entry.namespace,
    pathMatch: 'full' as const,
    redirectTo: entry.rootRedirect!.replace(/^\//, '')
  }));

export const MODERN_FRAME_DEFAULT_ROUTE = getModernFrameDefaultRoute();

export const MODERN_FRAME_MATCHER_ROUTE: Route = {
  matcher: modernFrameMatcher,
  loadComponent: () =>
    import('../modern-host/modern-route-marker.component').then((m) => m.ModernRouteMarkerComponent),
  canActivate: AUTH_GUARDS,
  resolve: { logCreated: createLogResolver() },
  data: { breadcrumb: { skip: true } }
};
